import api from "./api";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function catcherror(error) {
  console.log(error);
  // Silently ignore timeout errors — no toast shown
  if (error.code === 'ECONNABORTED' || (error.message && error.message.toLowerCase().includes('timeout'))) {
    return;
  }
  if (!error.response) {
    toast.error(error.message || "Network error. Please check your connection.");
    return;
  }
  if (error.response.status === 401) {
    localStorage.clear();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title: "There are few errors occurred while processing the request.",
      showCancelButton: false,
      confirmButtonColor: "#6259ca",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  }
}

// ── Salary Components ────────────────────────────────────────

export async function salaryComponentCreate(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/createsalarycomponent", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function salaryComponentList(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/listsalarycomponent", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function salaryComponentView(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/viewsalarycomponent/${id}`, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function salaryComponentDelete(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/deletesalarycomponent/${id}`, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

// ── Salary Structures ────────────────────────────────────────

export async function salaryStructureCreate(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" };
    return await api.post("/createsalarystructure", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function salaryStructureList(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/listsalarystructure", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function salaryStructureView(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/viewsalarystructure/${id}`, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function salaryStructureDelete(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/deletesalarystructure/${id}`, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

// ── Payroll Processing ───────────────────────────────────────

export async function generatePayroll(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/generatepayroll", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function listPayroll(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/listpayroll", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function payrollDetail(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/payrolldetail", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function approvePayroll(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/approvepayroll", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function markPayrollPaid(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/markpayrollpaid", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function regeneratePayrollVoucher(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/regeneratepayrollvoucher", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function deletePayroll(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/deletepayroll/${id}`, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function updatePayrollItem(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" };
    return await api.post("/updatepayrollitem", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function getPayslip(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/payslip/${id}`, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

// ── Salary Advances ──────────────────────────────────────────

export async function salaryAdvanceCreate(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/createsalaryadvance", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function salaryAdvanceList(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/listsalaryadvance", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function approveSalaryAdvance(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/approvesalaryadvance", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function rejectSalaryAdvance(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/rejectsalaryadvance", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

// ── Reports ──────────────────────────────────────────────────

export async function salaryRegister(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/salaryregister", data, { headers: header }).then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}
